import { useSelector } from "react-redux";
import { selectUser } from "modules/auth/redux/selectors";
import { EVENT_CONTEXT } from "modules/event/eventView/EventViewContext";
import useRegisterToEvent from "modules/event/hooks/useRegisterToEvent";
import { useContext, useEffect } from "react";

export const useEventContext = () => {
  const { getEventMemberData } = useRegisterToEvent();
  const user = useSelector(selectUser);
  const {
    eventMember,
    setEventMember,
    isEventDataLoading,
    event,
    eventCompany,
  } = useContext(EVENT_CONTEXT);

  useEffect(() => {
    if (user && event?.id && !eventMember) {
      // eslint-disable-next-line promise/catch-or-return, promise/prefer-await-to-then
      getEventMemberData(event?.id).then((eventMemberData) => {
        // eslint-disable-next-line promise/always-return
        if (eventMemberData) {
          setEventMember(eventMemberData);
        }
      });
    } else if (!user || !event?.id) {
      /**
       * Only set the event member to null if we either don't have user or event data.
       * Without the if condition in the else block, we saw that when the user tried to
       * register for an event, the "Save me a spot" button would disable and enable again
       * even if the registration was successful. That's because if we have user, eventData
       * and eventMember, then we would execute this else block. Putting a condition in this
       * else block solves this problem.
       */
      setEventMember(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, event?.id]);

  return { eventMember, isEventDataLoading, event, eventCompany };
};
